<template>
    <div>
        <h1 class="overskrift">Klubbkveld</h1>
        <b-button
                label="Sjekk inn medlem" 
                type="is-link"
                size="is-small"
                style="margin-bottom:1em;margin-right:1em;"
                @click="nyMedlem()"
            />
        <b-button
                label="Sjekk inn gjest" 
                type="is-link"
                size="is-small"
                style="margin-bottom:1em;"
                @click="nyGjest()"
            />

        <!-- Vis liste over spillere som er innsjekket i dag - sortert etter klokkeslett -->
        <ApolloQuery 
            :query="require('../graphql/klubbkveldliste.gql')"
            :variables="{fra}"
            :pollInterval="7000"
            >
            <template slot-scope="{ result: { data } } ">                    
                <div v-if="data">                                                
                    <table class="table is-bordered is-hoverable">
                        <thead>
                            <tr>
                                <th>Fornavn</th>
                                <th>Etternavn</th>
                                <th>Fødselsår</th>
                                <th>Type</th>
                                <th>Innsjekk</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody> 
                            <tr 
                                v-for="post in data.klubbkvelds" :key="post.id" 
                                :class="post.innsjekket ? 'has-text-success' : 'has-text-danger'"
                                >                           
                                <td>{{post.fornavn}}</td>
                                <td>{{post.etternavn}}</td>
                                <td align="center">{{sjekkFodsel(post.fodselsar)}}</td>
                                <td align="center">{{sjekkType(post.medlem)}}</td>
                                <td align="center">{{moment(post.createdAt).format('LT')}}</td>
                                <td>
                                    <button 
                                        class="button is-small is-warning" 
                                        @click="sjekkut(post.id)"
                                    > Sjekk ut </button>
                                </td> 
                            </tr>                          
                        </tbody>
                    </table>                    
                </div>
            </template>
        </ApolloQuery>

      <b-button
            label="Sjekk inn medlem" 
            type="is-link"
            size="is-small"
            style="margin-top:1em;margin-right:1em;"
            @click="nyMedlem()"
        />
      <b-button
            label="Sjekk inn gjest" 
            type="is-link"
            size="is-small"
            style="margin-top:1em;"
            @click="nyGjest()"
        />        

        <p class="has-text-success is-size-6" style="margin-top:0.5em;">Grønn = Innsjekket</p>
        <p class="has-text-danger is-size-6">Rød = Utsjekket</p>

        <!-- nyMedlem -->    
        <div class="modal" v-show="showMedlem" @close="showMedlem = false" :class="{'is-active' : showMedlem}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Sjekk inn medlem</p>
                    <button class="delete" aria-label="close" @click="showMedlem = false"></button>
                </header>
                <section class="modal-card-body">        
                    <ApolloQuery 
                        :query="require('../graphql/medlemsregister.gql')"
                        :variables="{fra}"            
                        >
                        <template slot-scope="{ result: { data } } ">                    
                            <div v-if="data">                                                
                                <b-field label="Velg et medlem fra lista">
                                    <b-select v-model="medlem" placeholder="Velg et medlem">
                                        <option
                                            v-for="post in data.medlemsregisters" 
                                            :key="post.id"
                                            :value="[post.id, post.fornavn, post.etternavn, post.fodselsar]"
                                            >
                                            {{ post.fornavn }} {{ post.etternavn }}
                                        </option>
                                    </b-select>
                                </b-field> 
                                <div class="buttons" style="margin-top:2em;">
                                    <b-button
                                        label="Lagre" 
                                        type="is-success"
                                        size="is-medium"
                                        @click="lagreMedlem()"
                                        />
                                    <b-button 
                                        label="Avbryt" 
                                        size="is-medium"
                                        @click="showMedlem = false"
                                        />
                                </div>   
                            </div>
                        </template>
                    </ApolloQuery>                       
                </section>
            </div>
        </div>            


        <!-- nyGjest -->    
        <div class="modal" v-show="showGjest" @close="showGjest = false" :class="{'is-active' : showGjest}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Sjekk inn gjest</p>
                    <button class="delete" aria-label="close" @click="showGjest = false"></button>
                </header>
                <section class="modal-card-body">         
                    <div class="field">
                        <label class="label">Fornavn</label>
                        <div class="control">
                            <input class="input" type="text" v-model="gjestFornavn" />
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Etternavn</label>
                        <div class="control">
                            <input class="input" type="text" v-model="gjestEtternavn"  />
                        </div>
                    </div>   
                    <div class="field">
                        <label class="label">Fødselsår</label>
                        <div class="control">
                            <input class="input" type="text" v-model="gjestFodselsar" />
                        </div>
                    </div>  
                    <div class="buttons" style="margin-top:2em;">
                        <b-button
                            label="Lagre ny" 
                            type="is-success"
                            size="is-medium"
                            @click="addGjest()"
                            />
                        <b-button 
                            label="Avbryt" 
                            size="is-medium"
                            @click="showGjest = false"
                            />
                    </div>     
                </section>
            </div>
        </div>            

        <!-- sjekkut -->    
        <div class="modal" v-show="showUtsjekk" @close="showUtsjekk = false" :class="{'is-active' : showUtsjekk}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Utsjekking</p>
                    <button class="delete" aria-label="close" @click="showUtsjekk = false"></button>
                </header>
                <section class="modal-card-body">         
                    <!-- content -->
                    <p>{{ this.utsjekking[1] }} har spilt i {{ this.utsjekking[7] }} minutter og har timepris kr. {{ this.utsjekking[6] }},- (<span v-if="utsjekking[4]">Medlem</span><span v-if="!utsjekking[4]">Gjest</span>/{{utsjekking[3]}}). Det blir totalt <strong>kr. {{ this.regnPris(utsjekking[6], utsjekking[7]) }},-</strong>.</p>

                    <p v-if="(this.totalSpillere >= 8)" class="has-text-danger" style="margin-top:1em;">Men siden det var totalt {{ this.totalSpillere }} spillere med i dag, så er timeprisen redusert og {{ this.utsjekking[1] }} skal kun betale <strong>kr. {{ this.regnRedusertPris(utsjekking[6], utsjekking[7], utsjekking[3]) }},-</strong>.</p>

                    <p v-if="(this.totalSpillere >= 8) && this.utsjekking[3] == 'Junior'" style="margin-top:1em;" class="is-size-6">Juniorer får 25% rabatt når det er flere enn 8 spiller med på klubbkvelden.</p>

                    <div class="buttons" style="margin-top:2em;">
                        <b-button
                            label="Bekreft og sjekk ut" 
                            type="is-success"
                            size="is-medium"
                            @click="sjekkUtBekreftet()"
                            />
                        <b-button 
                            label="Avbryt" 
                            size="is-medium"
                            @click="showUtsjekk = false"
                            />
                    </div>                     
                </section>
            </div>
        </div>  

    </div>
</template>

<script>
    import moment from 'moment'
    import settings from '../assets/settings.js'

    export default {
        name: "Klubbkveld",
        data() {
            return {
                idag: moment(),
                showMedlem: false,
                showGjest: false,
                showUtsjekk: false,
                gjestFornavn: "",
                gjestEtternavn: "",
                gjestFodselsar: "",
                fra: "",
                medlem: [],
                forstemann: "",
                innstillinger: "",
                utsjekking: [],
                totalSpillere: 0
            }
        },
        methods: {
            nyMedlem() {
                this.showMedlem = true;
            },
            nyGjest() {
                this.showGjest = true;
            },
            sjekkFodsel(value) {
                let iaar = parseInt(new Date().getFullYear());
                let born = parseInt(value)
                let senior = iaar - 18
                if (born < senior) {
                    return "Senior"
                } else { 
                    return "Junior"
                }                
            },
            sjekkType(value) {
                if (value === true) {
                    return "Medlem"
                } else {
                    return "Gjest"
                }              
            },
            addGjest() {
                // Mutiation som oppdaterer databasen
                // Trenger ikke tidspunkt - bruk CreatedAt
                this.$apollo.mutate({
                    mutation: require("../graphql/klubbgjest.gql"),
                    variables: {
                        fornavn: this.gjestFornavn,
                        etternavn: this.gjestEtternavn,
                        fodselsar: parseInt(this.gjestFodselsar),
                        innsjekket: true,
                        medlem: false
                    }
                })                
                this.$buefy.toast.open({
                    message: 'Gjesten er registrert<br/>Listen oppdateres om noen sekunder.',
                    type: 'is-success',
                    duration: 5000                
                })                
                this.showGjest = false;                
            },
            lagreMedlem() {
                // Mutiation som oppdaterer databasen
                // Trenger ikke tidspunkt - bruk CreatedAt
                this.$apollo.mutate({
                    mutation: require("../graphql/klubbgjest.gql"),
                    variables: {
                        fornavn: this.medlem[1],
                        etternavn: this.medlem[2],
                        fodselsar: parseInt(this.medlem[3]),
                        innsjekket: true,
                        medlem: true
                    }
                })                
                this.$buefy.toast.open({
                    message: 'Medlemmet er registrert<br/>Listen oppdateres om noen sekunder.',
                    type: 'is-success',
                    duration: 5000                
                })                      
                this.showMedlem = false;
            },
            sjekkut(value) {                        
                let utsjekkTid = moment(new Date()).format();
                this.showUtsjekk = true;   
                // value er ID i klubbkveldregisteret               
                // Sjekk om dette er førstemann som sjekker ut
                // og oppdater databasen deretter
                if(!this.innstillinger.forstemannUt) {
                    console.log("Førstemann til å sjekke ut")
                    this.$apollo.mutate({
                        mutation: require("../graphql/innstillingerUpdate.gql"),
                        variables: {
                            forstemannUt: true, 
                            klubbkveld: moment(this.fra).format('YYYY-MM-DD'),                            
                        }
                    })                      
                }

                // Regn ut hva vedkommende skal betale og vis i modal
                // Hent først data på deltager (medlem/gjest/junior)
                this.$apollo.query({
                    query: require("../graphql/klubbkveldfirst.gql"),
                    variables: { id: value}
                })
                    .then( result => this.utsjekking = [result.data.klubbkvelds[0].id, result.data.klubbkvelds[0].fornavn, result.data.klubbkvelds[0].etternavn, this.sjekkFodsel(result.data.klubbkvelds[0].fodselsar), result.data.klubbkvelds[0].medlem, result.data.klubbkvelds[0].createdAt])
                    .then( () => {
                        // Medlem eller ikke | Junior eller Senior
                        // Beregner timepris og legger i arrayet
                        if(this.utsjekking[4]){
                            if(this.utsjekking[3] === "Senior") {
                                this.utsjekking.push(settings.prisMedlem)
                            } else {
                                this.utsjekking.push(settings.prisJuniorMedlem)
                            }
                        } else {
                            if(this.utsjekking[3] === "Senior") {
                                this.utsjekking.push(settings.prisGjest)
                            } else {
                                this.utsjekking.push(settings.prisJuniorGjest)
                            }
                        }
                        //Beregner tidsforbruk og legger inn i arrayet
                        let minutter = moment(utsjekkTid).diff(moment(this.utsjekking[5]), 'minutes');
                        this.utsjekking.push(minutter);
                    })                          
            },
            sjekkUtBekreftet() {
                // Sjekk deltageren ut av klubbkveld.
                // Mutiation som oppdaterer databasen
                this.$apollo.mutate({
                    mutation: require("../graphql/klubbgjestUpdate.gql"),
                    variables: {
                        id: this.utsjekking[0],   
                        innsjekket: false,
                    }
                })    
                this.$buefy.toast.open({
                    message: 'Spilleren er sjekket ut.<br/>Listen oppdateres om noen sekunder.',
                    type: 'is-success',
                    duration: 5000                
                })                         
                this.showUtsjekk = false;

            },
            nyDag(value){
                if (value.klubbkveld === moment(this.fra).format('YYYY-MM-DD')) {
                    // Behøver vel ikke gjøre noe her
                } else { 
                    // Endre innstillinger.klubbkveld til dagens dato
                    // Sett innstillinger.forstemannUt til false
                    this.$apollo.mutate({
                        mutation: require("../graphql/innstillingerUpdate.gql"),
                        variables: {
                            forstemannUt: false,
                            klubbkveld: moment(this.fra).format('YYYY-MM-DD'),
                            id: "ckuboe4pc07lj0c60414o9r30"
                        }
                    })                         
                }                
            },
            totalPlayers(){
                // Finn ut hvor mange spillere som er med totalt
                this.$apollo.query({
                    query: require('../graphql/klubbkveldliste.gql'),
                    variables: { fra: moment(this.fra).format() }
                }).then( result => this.totalSpillere = result.data.klubbkvelds.length )                
            },
            regnPris(a,b) {
                let pris = Math.round((a/60)*b);
                return pris
            },
            regnRedusertPris(timepris, minutter, junior) {
                let maxpris = settings.maxPrisKlubbkveld / this.totalSpillere;
                let pris
                let startPris = Math.round((timepris/60)*minutter);

                if (startPris >= maxpris) { pris = maxpris }
                
                if ((this.totalSpillere >=8) && (junior === "Junior")) {
                    return Math.round(startPris * 0.75)              
                    } else { return Math.round((pris/60)*minutter) }   
            }
        },
        mounted() {
            // Finn starten av dagen    
            var fra = new Date();
            var fra2 = fra.setHours(0,0,0,0);
            this.fra = moment(fra2).format();

            this.totalPlayers()

            // Hent diverse innstillinger
            this.$apollo.query({
                query: require("../graphql/innstillinger.gql")
            })
                .then( result => this.innstillinger = result.data.innstillinger)
                .then( result => this.nyDag(result)  ) 
        }
    }
</script>